import { PRODUCT_PREFERENCE_OPTIONS } from "@/utils/productPreferences";

export function createProductFormState() {
  return {
    form: {
      name: "",
      description: "",
      imagesUrls: [],
      stoneSize: "",
      preferences: [],
      preferenceWeights: {},
      sortOrder: 0,
      price: 0,
      quoteOnly: false,
    },
    preferenceOptions: PRODUCT_PREFERENCE_OPTIONS,
    isEdit: false,
    loading: false,
    submitting: false,
  };
}
